'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icons = require('@brandwatch/axiom-materials/dist/icons');

var _icons2 = _interopRequireDefault(_icons);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

require('./Icon.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          inline = _props.inline,
          name = _props.name,
          size = _props.size,
          width = _props.width,
          height = _props.height,
          spaceLeft = _props.spaceLeft,
          spaceRight = _props.spaceRight,
          rest = _objectWithoutProperties(_props, ['className', 'inline', 'name', 'size', 'width', 'height', 'spaceLeft', 'spaceRight']);

      var style = height || width ? { width: width, height: height } : { width: size, height: size };

      var classes = (0, _classnames3.default)(className, 'ax-icon', 'ax-icon--' + name, (_classnames = {
        'ax-icon--inline': inline
      }, _defineProperty(_classnames, 'ax-icon--space-left-' + spaceLeft, spaceLeft), _defineProperty(_classnames, 'ax-icon--space-right-' + spaceRight, spaceRight), _classnames));

      if (!_icons2.default[name]) {
        return null;
      }

      var _icons$name = _icons2.default[name],
          body = _icons$name.body,
          viewBox = _icons$name.viewBox;


      return _react2.default.createElement(_Base2.default, _extends({}, rest, {
        Component: 'svg',
        className: classes,
        dangerouslySetInnerHTML: { __html: body },
        style: style,
        viewBox: viewBox }));
    }
  }]);

  return Icon;
}(_react.Component);

Icon.propTypes = {
  /** SKIP */
  className: _propTypes2.default.string,
  /**
   * Inline styling that allows the Icon to placed next to other inline
   * elements or text.
   */
  /** Height of icon (with unit). */
  height: _propTypes2.default.string,
  inline: _propTypes2.default.bool,
  /** Name of the icon that will be displayed */
  name: _propTypes2.default.oneOf(['annotate', 'analytics-alert', 'arrow-down', 'arrow-down-left', 'arrow-down-right', 'arrow-up', 'arrow-up-left', 'arrow-up-right', 'at', 'bar-chart', 'benchmark', 'box-collapse', 'box-expand', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'clock', 'cloud-upload', 'cross', 'customise', 'data', 'deck', 'dot', 'dot-outline', 'double-chevron-left', 'double-chevron-right', 'drag', 'duplicate', 'ellipsis', 'email', 'exclude', 'facebook', 'filter', 'flip-horizontal', 'flip-vertical', 'folder', 'folder-closed', 'followers', 'form-resize', 'format-bold', 'format-italic', 'format-title', 'format-underline', 'grid', 'growth', 'hamburger', 'heart', 'home', 'information', 'input', 'information-circle', 'installation', 'instagram', 'integrations', 'iris', 'kred', 'line-graph', 'list', 'location', 'lock', 'log', 'magnify-glass', 'minus', 'monitor', 'moon', 'open', 'pencil', 'pinterest', 'plugin', 'plus', 'preview', 'question-mark', 'question-mark-circle', 'reddit', 'refresh', 'replace', 'reply', 'reports', 'retweet', 'ring', 'settings', 'share', 'star', 'sun', 'switch', 'tag', 'tick', 'tools', 'trash', 'triangle-down', 'triangle-left', 'triangle-right', 'triangle-up', 'twitter', 'unlock', 'user', 'warning', 'warning-circle']).isRequired,
  /** Size of icon (with unit). Not used when height or width is provided */
  size: _propTypes2.default.string,
  /** Spacing applied to the left of the Icon. Must be used with the inline property */
  spaceLeft: _propTypes2.default.oneOf(['x1', 'x2']),
  /** Spacing applied to the right of the Icon. Must be used with the inline property */
  spaceRight: _propTypes2.default.oneOf(['x1', 'x2']),
  /** Width of icon (with unit). */
  width: _propTypes2.default.string
};
Icon.defaultProps = {
  size: '1rem'
};
exports.default = Icon;